import { render } from "./PizzaCarousel.vue?vue&type=template&id=22871f66&scoped=true"
import script from "./PizzaCarousel.vue?vue&type=script&lang=js"
export * from "./PizzaCarousel.vue?vue&type=script&lang=js"

import "./PizzaCarousel.vue?vue&type=style&index=0&id=22871f66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22871f66"]])

export default __exports__